const VIEW_EDITABLE_COMPONENT_PATHS = Object.freeze({
  Calendar: ['single_item.main_section.main_content'],
  Cards: ['single_item.main_section.main_content'],
  Content: [],
  Form: ['single_item.main_section.main_content'],
  Kanban: [
    'single_item.main_section.main_content',
    'index.main_section.column_group_by',
  ],
  Matrix: [
    'single_item.main_section.main_content',
    'index.main_section.column_group_by',
    'index.main_section.row_group_by',
  ],
  Report: [],
  Table: ['index.main_section.main_content'],
  Timeline: ['index.main_section.main_content'],
  Tree: ['single_item.main_section.main_content'],
});

const VIEWS_COMPONENTS = Object.freeze({
  Cards: [
    {
      key: 'index',
      icon: 'fa-rectangle-history fa-regular',
      locales: {
        pt: 'Coleção',
        en: 'Collection',
      },
      header_section: {
        exodiaComponents: {
          title: {
            type: 'text',
          },
          profile_image: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'image',
            ],
          },
          cover_image: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'image',
            ],
          },
          main_content: {
            type: 'info-components',
          },
        },
        editRecordMode: 'disabled',
        openRecordMode: 'none',
      },
      main_section: {
        exodiaComponents: {
          title: {
            type: 'field-select',
          },
          profile_image: {
            type: 'field-select',
          },
          main_content: {
            type: 'info-components',
          },
          visibility: {
            type: 'text',
          },
        },
        editRecordMode: 'disabled',
        openRecordMode: 'page',
      },
    },
    {
      key: 'single_item',
      icon: 'fa-rectangle fa-regular',
      locales: {
        pt: 'Entrada',
        en: 'Record',
      },
      header_section: {
        exodiaComponents: {
          title: {
            type: 'text',
          },
          profile_image: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'image',
            ],
          },
          cover_image: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'image',
            ],
          },
          main_content: {
            type: 'info-components',
          },
        },
        editRecordMode: 'disabled',
        openRecordMode: 'none',
      },
      main_section: {
        exodiaComponents: {
          title: {
            type: 'field-select',
          },
          profile_image: {
            type: 'field-select',
          },
          main_content: {
            type: 'info-components',
          },
          primary_button: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'action-button',
            ],
          },
          secondary_button: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'action-button',
            ],
          },
        },
        editRecordMode: 'in_place',
        openRecordMode: 'page',
        submitButtonKey: 'primary_button',
      },
    },
  ],
  Content: [
    {
      key: 'single_item',
      icon: 'fa-memo fa-regular',
      locales: {
        pt: 'Conteúdo',
        en: 'Content',
      },
      main_section: {
        exodiaComponents: {
          main_content: {
            type: 'info-components',
          },
        },
        editRecordMode: 'disabled',
        openRecordMode: 'none',
      },
    },
  ],
  Form: [
    {
      key: 'index',
      icon: 'fa-rectangle-history fa-regular',
      locales: {
        pt: 'Coleção',
        en: 'Collection',
      },
      header_section: {
        exodiaComponents: {
          title: {
            type: 'text',
          },
          profile_image: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'image',
            ],
          },
          cover_image: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'image',
            ],
          },
          main_content: {
            type: 'info-components',
          },
        },
        editRecordMode: 'disabled',
        openRecordMode: 'none',
      },
      main_section: {
        exodiaComponents: {
          title: {
            type: 'field-select',
          },
          profile_image: {
            type: 'field-select',
          },
          main_content: {
            type: 'info-components',
          },
          visibility: {
            type: 'text',
          },
        },
        editRecordMode: 'disabled',
        openRecordMode: 'page',
      },
    },
    {
      key: 'single_item',
      icon: 'fa-pen-field fa-regular',
      locales: {
        pt: 'Formulário',
        en: 'Form',
      },
      header_section: {
        exodiaComponents: {
          title: {
            type: 'text',
          },
          profile_image: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'image',
            ],
          },
          cover_image: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'image',
            ],
          },
          main_content: {
            type: 'info-components',
          },
        },
        editRecordMode: 'disabled',
        openRecordMode: 'none',
      },
      main_section: {
        exodiaComponents: {
          title: {
            type: 'text',
          },
          profile_image: {
            type: 'field-select',
          },
          main_content: {
            type: 'info-components',
          },
          submit_button: {
            type: 'info-component-select',
            required: true,
            infoComponents: [
              'action-button',
            ],
          },
        },
        editRecordMode: 'submit',
        openRecordMode: 'page',
        submitButtonKey: 'submit_button',
      },
    },
  ],
  Kanban: [
    {
      key: 'index',
      icon: 'fa-square-kanban fa-regular',
      locales: {
        pt: 'Kanban',
        en: 'Kanban',
      },
      header_section: {
        exodiaComponents: {
          title: {
            type: 'text',
          },
          profile_image: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'image',
            ],
          },
          cover_image: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'image',
            ],
          },
          main_content: {
            type: 'info-components',
          },
        },
        editRecordMode: 'disabled',
        openRecordMode: 'none',
      },
      main_section: {
        exodiaComponents: {
          title: {
            type: 'field-select',
          },
          main_content: {
            type: 'info-components',
          },
        },
        editRecordMode: 'disabled',
        openRecordMode: 'dialog',
      },
    },
    {
      key: 'single_item',
      icon: 'fa-rectangle fa-regular',
      locales: {
        pt: 'Entrada',
        en: 'Record',
      },
      main_section: {
        exodiaComponents: {
          title: {
            type: 'field-select',
          },
          main_content: {
            type: 'info-components',
          },
          primary_button: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'action-button',
            ],
          },
          secondary_button: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'action-button',
            ],
          },
        },
        editRecordMode: 'in_place',
        openRecordMode: 'dialog',
        submitButtonKey: 'primary_button',
      },
    },
  ],
  Matrix: [
    {
      key: 'index',
      icon: 'fa-grid-2 fa-regular',
      locales: {
        pt: 'Matriz',
        en: 'Matrix',
      },
      header_section: {
        exodiaComponents: {
          title: {
            type: 'text',
          },
          profile_image: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'image',
            ],
          },
          cover_image: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'image',
            ],
          },
          main_content: {
            type: 'info-components',
          },
        },
        editRecordMode: 'disabled',
        openRecordMode: 'none',
      },
      main_section: {
        exodiaComponents: {
          title: {
            type: 'field-select',
          },
          main_content: {
            type: 'info-components',
          },
        },
        editRecordMode: 'disabled',
        openRecordMode: 'dialog',
      },
    },
    {
      key: 'single_item',
      icon: 'fa-rectangle fa-regular',
      locales: {
        pt: 'Entrada',
        en: 'Record',
      },
      main_section: {
        exodiaComponents: {
          title: {
            type: 'field-select',
          },
          main_content: {
            type: 'info-components',
          },
          primary_button: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'action-button',
            ],
          },
          secondary_button: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'action-button',
            ],
          },
        },
        editRecordMode: 'in_place',
        openRecordMode: 'dialog',
        submitButtonKey: 'primary_button',
      },
    },
  ],
  Calendar: [
    {
      key: 'index',
      icon: 'fa-calendar fa-regular',
      locales: {
        pt: 'Calendário',
        en: 'Calendar',
      },
      header_section: {
        exodiaComponents: {
          title: {
            type: 'text',
          },
          profile_image: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'image',
            ],
          },
          cover_image: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'image',
            ],
          },
          main_content: {
            type: 'info-components',
          },
        },
        editRecordMode: 'disabled',
        openRecordMode: 'none',
      },
      main_section: {
        exodiaComponents: {
          title: {
            type: 'field-select',
          },
        },
        editRecordMode: 'disabled',
        openRecordMode: 'page',
      },
    },
    {
      key: 'single_item',
      icon: 'fa-rectangle fa-regular',
      locales: {
        pt: 'Entrada',
        en: 'Record',
      },
      main_section: {
        exodiaComponents: {
          title: {
            type: 'field-select',
          },
          profile_image: {
            type: 'field-select',
          },
          main_content: {
            type: 'info-components',
          },
          primary_button: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'action-button',
            ],
          },
          secondary_button: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'action-button',
            ],
          },
        },
        editRecordMode: 'in_place',
        openRecordMode: 'page',
        submitButtonKey: 'primary_button',
      },
    },
  ],
  Report: [
    {
      key: 'single_item',
      icon: 'fa-regular fa-file-contract',
      locales: {
        pt: 'Relatório',
        en: 'Report',
      },
      main_section: {
        exodiaComponents: {
          main_content: {
            type: 'info-components',
          },
        },
        editRecordMode: 'disabled',
        openRecordMode: 'none',
      },
    },
  ],
  Table: [
    {
      key: 'index',
      icon: 'fa-table fa-regular',
      locales: {
        pt: 'Tabela',
        en: 'Table',
      },
      header_section: {
        exodiaComponents: {
          title: {
            type: 'text',
          },
          profile_image: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'image',
            ],
          },
          cover_image: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'image',
            ],
          },
          main_content: {
            type: 'info-components',
          },
        },
        editRecordMode: 'disabled',
        openRecordMode: 'none',
      },
      main_section: {
        exodiaComponents: {
          main_content: {
            type: 'info-components',
          },
        },
        editRecordMode: 'in_place',
        openRecordMode: 'none',
      },
    },
  ],
  Timeline: [
    {
      key: 'index',
      icon: 'fa-square-list fa-regular',
      locales: {
        pt: 'Formulário',
        en: 'Form',
      },
      header_section: {
        exodiaComponents: {
          title: {
            type: 'text',
          },
          profile_image: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'image',
            ],
          },
          cover_image: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'image',
            ],
          },
          main_content: {
            type: 'info-components',
          },
        },
        editRecordMode: 'disabled',
        openRecordMode: 'none',
      },
      main_section: {
        exodiaComponents: {
          title: {
            type: 'text',
          },
          main_content: {
            type: 'info-components',
          },
          submit_button: {
            type: 'info-component-select',
            required: true,
            infoComponents: [
              'action-button',
            ],
          },
        },
        editRecordMode: 'submit',
        openRecordMode: 'none',
        submitButtonKey: 'submit_button',
      },
    },
    {
      key: 'single_item',
      icon: 'fa-rectangle fa-regular',
      locales: {
        pt: 'Coleção',
        en: 'Collection',
      },
      main_section: {
        exodiaComponents: {
          title: {
            type: 'field-select',
          },
          subtitle: {
            type: 'field-select',
          },
          avatar_image: {
            type: 'field-select',
          },
          cover_image: {
            type: 'field-select',
          },
          main_content: {
            type: 'info-components',
          },
          primary_button: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'action-button',
            ],
          },
          secondary_button: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'action-button',
            ],
          },
          footer_content: {
            type: 'field-select',
          },
        },
        editRecordMode: 'disabled',
        openRecordMode: 'none',
        submitButtonKey: 'primary_button',
      },
    },
  ],
  Tree: [
    {
      key: 'index',
      icon: 'fa-sitemap fa-regular',
      locales: {
        pt: 'Árvore',
        en: 'Tree',
      },
      header_section: {
        exodiaComponents: {
          title: {
            type: 'text',
          },
          profile_image: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'image',
            ],
          },
          cover_image: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'image',
            ],
          },
          main_content: {
            type: 'info-components',
          },
        },
        editRecordMode: 'disabled',
        openRecordMode: 'none',
      },
      main_section: {
        exodiaComponents: {
          title: {
            type: 'field-select',
          },
          avatar_image: {
            type: 'field-select',
          },
          main_content: {
            type: 'info-components',
          },
          footer_content: {
            type: 'field-select',
          },
        },
        editRecordMode: 'disabled',
        openRecordMode: 'dialog',
      },
    },
    {
      key: 'single_item',
      icon: 'fa-rectangle fa-regular',
      locales: {
        pt: 'Entrada',
        en: 'Record',
      },
      main_section: {
        exodiaComponents: {
          title: {
            type: 'field-select',
          },
          profile_image: {
            type: 'field-select',
          },
          main_content: {
            type: 'info-components',
          },
          primary_button: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'action-button',
            ],
          },
          secondary_button: {
            type: 'info-component-select',
            required: false,
            infoComponents: [
              'action-button',
            ],
          },
          footer_content: {
            type: 'field-select',
          },
        },
        editRecordMode: 'in_place',
        openRecordMode: 'dialog',
        submitButtonKey: 'primary_button',
      },
    },
  ],
});

const VIEWS_BUILDER_OPTIONS = Object.freeze({
  Cards: {
    availableRedirectStates: [
      'index',
      'single_item',
      'new',
    ],
    availableDefaultStates: [
      'index',
      'single_item',
    ],
    canEditRecordsGroupColumn: false,
    canFilterDataByColumn: true,
    canGroupDataByColumn: true,
    canGroupDataByRow: false,
    canGroupMainContent: true,
    canSelectRecursiveField: false,
    canUseChartInfoComponent: true,
    canUseFieldInfoComponent: true,
    editableInfoComponentsKey: 'single_item',
    groupByFieldTypes: [],
    hasGlobalSearch: true,
    liveEdit: true,
    mustGroupDataByColumn: false,
    optionsWithFieldSelect: null,
    permitDelete: true,
    permitInsert: true,
    permitUpdate: true,
    readOnlySelectFields: false,
    showFilterRecords: true,
    showSelectFields: true,
    showSortByRecords: true,
  },
  Content: {
    availableRedirectStates: [
      'single_item',
    ],
    availableDefaultStates: [
      'single_item',
    ],
    canEditRecordsGroupColumn: false,
    canFilterDataByColumn: false,
    canGroupDataByColumn: false,
    canGroupDataByRow: false,
    canGroupMainContent: false,
    canSelectRecursiveField: false,
    canUseChartInfoComponent: false,
    canUseFieldInfoComponent: false,
    editableInfoComponentsKey: null,
    groupByFieldTypes: [],
    hasGlobalSearch: false,
    liveEdit: true,
    mustGroupDataByColumn: false,
    optionsWithFieldSelect: null,
    permitDelete: false,
    permitInsert: false,
    permitUpdate: false,
    readOnlySelectFields: true,
    showFilterRecords: false,
    showSelectFields: false,
    showSortByRecords: false,
  },
  Form: {
    availableRedirectStates: [
      'index',
      'single_item',
      'new',
    ],
    availableDefaultStates: [
      'index',
      'single_item',
      'new',
    ],
    canEditRecordsGroupColumn: false,
    canFilterDataByColumn: true,
    canGroupDataByColumn: true,
    canGroupDataByRow: false,
    canGroupMainContent: true,
    canSelectRecursiveField: false,
    canUseChartInfoComponent: true,
    canUseFieldInfoComponent: true,
    editableInfoComponentsKey: 'single_item',
    groupByFieldTypes: [],
    hasGlobalSearch: true,
    liveEdit: false,
    mustGroupDataByColumn: false,
    optionsWithFieldSelect: null,
    permitDelete: true,
    permitInsert: true,
    permitUpdate: true,
    readOnlySelectFields: true,
    showFilterRecords: true,
    showSelectFields: true,
    showSortByRecords: true,
  },
  Kanban: {
    availableRedirectStates: [
      'index',
      'single_item',
    ],
    availableDefaultStates: [
      'index',
    ],
    canEditRecordsGroupColumn: true,
    canFilterDataByColumn: true,
    canGroupDataByColumn: true,
    canGroupDataByRow: false,
    canGroupMainContent: true,
    canSelectRecursiveField: false,
    canUseChartInfoComponent: true,
    canUseFieldInfoComponent: true,
    editableInfoComponentsKey: 'single_item',
    groupByFieldTypes: [
      'Select',
    ],
    hasGlobalSearch: false,
    liveEdit: true,
    mustGroupDataByColumn: true,
    optionsWithFieldSelect: null,
    permitDelete: true,
    permitInsert: true,
    permitUpdate: true,
    readOnlySelectFields: false,
    showFilterRecords: true,
    showSelectFields: true,
    showSortByRecords: true,
  },
  Matrix: {
    availableRedirectStates: [
      'index',
      'single_item',
    ],
    availableDefaultStates: [
      'index',
    ],
    canEditRecordsGroupColumn: true,
    canFilterDataByColumn: true,
    canGroupDataByColumn: true,
    canGroupDataByRow: true,
    canGroupMainContent: true,
    canSelectRecursiveField: false,
    canUseChartInfoComponent: true,
    canUseFieldInfoComponent: true,
    editableInfoComponentsKey: 'single_item',
    groupByFieldTypes: [
      'Select',
    ],
    hasGlobalSearch: false,
    liveEdit: true,
    mustGroupDataByColumn: true,
    optionsWithFieldSelect: null,
    permitDelete: true,
    permitInsert: true,
    permitUpdate: true,
    readOnlySelectFields: false,
    showFilterRecords: true,
    showSelectFields: true,
    showSortByRecords: true,
  },
  Calendar: {
    availableRedirectStates: [
      'index',
      'single_item',
    ],
    availableDefaultStates: [
      'index',
    ],
    canEditRecordsGroupColumn: false,
    canFilterDataByColumn: false,
    canGroupDataByColumn: false,
    canGroupDataByRow: false,
    canGroupMainContent: true,
    canSelectRecursiveField: false,
    canUseChartInfoComponent: true,
    canUseFieldInfoComponent: true,
    editableInfoComponentsKey: 'single_item',
    groupByFieldTypes: [],
    hasGlobalSearch: false,
    optionsWithFieldSelect: [
      {
        key: 'start_date',
        allowedFieldTypes: [
          'Date',
          'DateTime',
        ],
      },
      {
        key: 'end_date',
        allowedFieldTypes: [
          'Date',
          'DateTime',
        ],
      },
      {
        key: 'color',
        allowedFieldTypes: [
          'Link',
          'Select',
          'MultipleSelect',
        ],
      },
    ],
    liveEdit: true,
    mustGroupDataByColumn: false,
    permitDelete: true,
    permitInsert: true,
    permitUpdate: true,
    readOnlySelectFields: false,
    showFilterRecords: true,
    showSelectFields: true,
    showSortByRecords: true,
  },
  Report: {
    availableRedirectStates: [
      'single_item',
    ],
    availableDefaultStates: [
      'single_item',
    ],
    canEditRecordsGroupColumn: false,
    canFilterDataByColumn: true,
    canGroupDataByColumn: false,
    canGroupDataByRow: false,
    canGroupMainContent: false,
    canSelectRecursiveField: false,
    canUseChartInfoComponent: true,
    canUseFieldInfoComponent: false,
    editableInfoComponentsKey: null,
    groupByFieldTypes: [],
    hasGlobalSearch: false,
    liveEdit: true,
    mustGroupDataByColumn: true,
    optionsWithFieldSelect: null,
    permitDelete: false,
    permitInsert: false,
    permitUpdate: false,
    readOnlySelectFields: true,
    showFilterRecords: true,
    showSelectFields: false,
    showSortByRecords: false,
  },
  Table: {
    availableRedirectStates: [
      'index',
    ],
    availableDefaultStates: [
      'index',
    ],
    canEditRecordsGroupColumn: false,
    canFilterDataByColumn: true,
    canGroupDataByColumn: false,
    canGroupDataByRow: false,
    canGroupMainContent: true,
    canSelectRecursiveField: false,
    canUseChartInfoComponent: false,
    canUseFieldInfoComponent: true,
    editableInfoComponentsKey: 'index',
    groupByFieldTypes: [],
    hasGlobalSearch: false,
    liveEdit: true,
    mustGroupDataByColumn: false,
    optionsWithFieldSelect: null,
    permitDelete: true,
    permitInsert: true,
    permitUpdate: true,
    readOnlySelectFields: false,
    showFilterRecords: true,
    showSelectFields: true,
    showSortByRecords: true,
  },
  Timeline: {
    availableRedirectStates: [
      'index',
    ],
    availableDefaultStates: [
      'index',
    ],
    canEditRecordsGroupColumn: false,
    canFilterDataByColumn: true,
    canGroupDataByColumn: false,
    canGroupDataByRow: false,
    canGroupMainContent: false,
    canSelectRecursiveField: false,
    canUseChartInfoComponent: false,
    canUseFieldInfoComponent: true,
    editableInfoComponentsKey: 'index',
    groupByFieldTypes: [],
    hasGlobalSearch: false,
    liveEdit: false,
    mustGroupDataByColumn: false,
    optionsWithFieldSelect: null,
    permitDelete: true,
    permitInsert: true,
    permitUpdate: true,
    readOnlySelectFields: true,
    showFilterRecords: true,
    showSelectFields: true,
    showSortByRecords: true,
  },
  Tree: {
    availableRedirectStates: [
      'index',
      'single_item',
    ],
    availableDefaultStates: [
      'index',
    ],
    canEditRecordsGroupColumn: false,
    canFilterDataByColumn: false,
    canGroupDataByColumn: false,
    canGroupDataByRow: false,
    canGroupMainContent: false,
    canSelectRecursiveField: true,
    canUseChartInfoComponent: true,
    canUseFieldInfoComponent: true,
    editableInfoComponentsKey: 'single_item',
    groupByFieldTypes: [],
    hasGlobalSearch: false,
    liveEdit: true,
    mustGroupDataByColumn: false,
    optionsWithFieldSelect: null,
    permitDelete: true,
    permitInsert: true,
    permitUpdate: true,
    readOnlySelectFields: false,
    showFilterRecords: true,
    showSelectFields: true,
    showSortByRecords: false,
  },
});

const VIEWS_BASE = Object.freeze({
  Cards: {
    position: 2,
    canBePublic: true,
    icon: 'fa-rectangle-history fa-regular',
    rawIcon: 'rectangle-history',
    locales: {
      pt: 'Cards',
      en: 'Cards',
    },
    editInPlace: true,
  },
  Content: {
    position: 5,
    canBePublic: true,
    icon: 'fa-memo fa-regular',
    rawIcon: 'memo',
    locales: {
      pt: 'Conteúdo',
      en: 'Content',
    },
    editInPlace: false,
  },
  Form: {
    position: 3,
    canBePublic: true,
    icon: 'fa-pen-field fa-regular',
    rawIcon: 'pen-field',
    locales: {
      pt: 'Formulário',
      en: 'Form',
    },
    editInPlace: false,
  },
  Kanban: {
    position: 6,
    canBePublic: true,
    icon: 'fa-square-kanban fa-regular',
    rawIcon: 'square-kanban',
    locales: {
      pt: 'Kanban',
      en: 'Kanban',
    },
    editInPlace: true,
  },
  Matrix: {
    position: 7,
    canBePublic: true,
    icon: 'fa-grid-2 fa-regular',
    rawIcon: 'grid-2',
    locales: {
      pt: 'Matriz',
      en: 'Matrix',
    },
    editInPlace: true,
  },
  Calendar: {
    position: 9,
    canBePublic: true,
    icon: 'fa-calendar fa-regular',
    rawIcon: 'calendar',
    locales: {
      pt: 'Calendário',
      en: 'Calendar',
    },
    editInPlace: false,
  },
  Report: {
    position: 8,
    canBePublic: true,
    icon: 'fa-file-contract fa-regular',
    rawIcon: 'file-contract',
    locales: {
      pt: 'Relatório',
      en: 'Report',
    },
    editInPlace: false,
  },
  Table: {
    position: 1,
    canBePublic: true,
    icon: 'fa-table fa-regular',
    rawIcon: 'table',
    locales: {
      pt: 'Tabela',
      en: 'Table',
    },
    editInPlace: true,
  },
  Timeline: {
    position: 4,
    canBePublic: true,
    icon: 'fa-timeline fa-regular',
    rawIcon: 'timeline',
    locales: {
      pt: 'Feed',
      en: 'Feed',
    },
    editInPlace: true,
  },
  Tree: {
    position: 10,
    canBePublic: true,
    icon: 'fa-sitemap fa-regular',
    rawIcon: 'sitemap',
    locales: {
      pt: 'Árvore',
      en: 'Tree',
    },
    editInPlace: false,
  },
});

export default Object.freeze(Object.fromEntries(Object.entries(VIEWS_BASE).map(([key, value]) => [
  key,
  Object.freeze({
    ...value,
    builderOptions: VIEWS_BUILDER_OPTIONS[key],
    components: VIEWS_COMPONENTS[key],
    editableComponentPaths: VIEW_EDITABLE_COMPONENT_PATHS[key],
  }),
])));
